import React from 'react';

interface LocationIconProps {
  color?: string;
}

const LocationIcon: React.FC<LocationIconProps> = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M15.4,18.5 C18.9,18.9 21.4,20 21.4,21 C21.4,22.4 16.8,23.5 11.3,23.5 C5.8,23.5 1.3,22.4 1.3,21 C1.3,20 3.8,18.9 7.5,18.5 M11.5,20 C11.5,20 5.7,11.7 5.7,8.5 C5.6,5.2 8.3,2.4 11.5,2.3 C14.8,2.4 17.5,5.3 17.3,8.5 C17.3,11.7 11.5,20 11.5,20 Z M11.5,6 C12.9,6 14,7.1 14,8.5 C14,9.9 12.9,11 11.5,11 C10.1,11 9,9.9 9,8.5 C9,7.1 10.1,6 11.5,6 Z"
      stroke="currentColor"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    />
  </svg>
);

export default LocationIcon;
